export const whatsAppContainer = (showWhatsapp: boolean) =>
  `mr-5 flex items-center flex-col cursor-pointer px-5 py-2 ${
    showWhatsapp && 'bg-elr-gray-600 bg-opacity-30'
  }`;

export const smsContainer = (showSms: boolean) =>
  `flex items-center flex-col cursor-pointer px-5 py-2 ${
    showSms && 'bg-elr-gray-600 bg-opacity-30'
  }`;
